import DropZone from '../../DropZone';
import { AssetListEmptyState } from '../../AssetListEmptyState';
import { DropZoneArea } from '../../../types';
import { useUploadAssetsContext } from '../../../contexts/UploadAssetsContext';

export const TakeoverEmpty = () => {
  const { activeDropZone } = useUploadAssetsContext();

  return (
    <DropZone area={DropZoneArea.Takeover}>
      <AssetListEmptyState isDragging={activeDropZone === DropZoneArea.Takeover} />
    </DropZone>
  );
};
